import * as React from 'react';
import { Grid, useMediaQuery } from '@material-ui/core';
import { Magnetic as Mi } from '@mitchell/react.component.ux';
import { TranslationService } from "../../common";
import { AlbumGroup } from './AlbumGroup';
import { NestedTwisty } from './NestedTwisty';
import { DOWNLOAD_ARTIFACT } from '../constants';
/**
 * RecursiveAlbumRenderer - Renders albums and their nested subalbums in a hierarchical structure
 *
 * This component recursively renders albums and their subalbums using a twisty (expandable/collapsible)
 * interface. It maintains expansion state for each album independently.
 */
export const RecursiveAlbumRenderer = (props) => {
    const { albums, isChild = false, indentLevel = 0 } = props;
    const isSubLabelMaxWidthReached = useMediaQuery(`(max-width: ${Mi.layoutBreakpointSm})`);
    const [expandedState, setExpandedState] = React.useState({});
    React.useEffect(() => {
        const initialState = {};
        /**
         * Helper function to recursively set expansion state for all albums and their subalbums
         * @param albumsToExpand - The albums to process
         */
        const setAllExpanded = (albumsToExpand) => {
            albumsToExpand.forEach((album) => {
                initialState[album.id] = true;
                if (album.subAlbums && album.subAlbums.length > 0) {
                    setAllExpanded(album.subAlbums);
                }
            });
        };
        setAllExpanded(albums);
        setExpandedState(initialState);
    }, []);
    /**
     * Toggle the expansion state of a specific album
     * @param albumId - The ID of the album to toggle
     */
    const toggleCollapse = (albumId) => {
        setExpandedState(prevState => (Object.assign(Object.assign({}, prevState), { [albumId]: !prevState[albumId] })));
    };
    return (React.createElement("div", { "data-testid": `${DOWNLOAD_ARTIFACT.ID_RECURSIVE_ALBUM_RENDERER}_${indentLevel}` }, albums.map((album) => (React.createElement(NestedTwisty, { key: album.id, id: album.id, label: album.header, headingSubLabel: !isSubLabelMaxWidthReached ? album.subHeader : undefined, isExpanded: expandedState[album.id] !== false, onToggle: () => toggleCollapse(album.id), isChildTwisty: isChild, indentLevel: indentLevel, shouldExpandByDefault: true, "data-testid": `${DOWNLOAD_ARTIFACT.ID_RECURSIVE_ALBUM_RENDERER_TWISTY}_${album.id}` },
        React.createElement(AlbumGroup, Object.assign({}, props, { translateFn: TranslationService.translate, id: album.id, tiles: album.tiles, "data-testid": `${DOWNLOAD_ARTIFACT.ID_RECURSIVE_ALBUM_RENDERER_ALBUM_GROUP}_${album.id}` })),
        album.subAlbums && album.subAlbums.length > 0 && (React.createElement(Grid, { container: true, direction: "column", "data-testid": `${DOWNLOAD_ARTIFACT.ID_RECURSIVE_ALBUM_RENDERER_SUBALBUMS_GROUP}_-${album.id}` },
            React.createElement(RecursiveAlbumRenderer, Object.assign({}, props, { albums: album.subAlbums, isChild: true, indentLevel: indentLevel + 1, "data-testid": `${DOWNLOAD_ARTIFACT.ID_RECURSIVE_ALBUM_RENDERER_NESTED_RENDERER}_${album.id}` })))))))));
};
//# sourceMappingURL=RecursiveAlbumRenderer.js.map